import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { applyFilter } from './filterUsers'
import { UserEntity } from '@finance-lab/utils/types'

interface UsersFilterProps {
    users: UserEntity[]
    setUsers: (users: UserEntity[]) => void
    filterState: { enabledDisabled: string; userCategory: string }
    setFilterState: (filterState: { enabledDisabled: string; userCategory: string }) => void
}

/**
 * A dropdown filter with three options: All, Enabled, Disabled.
 */
function UsersFilter({ users, setUsers, filterState, setFilterState }: UsersFilterProps) {
    const handleChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target
        const newFilterState = { ...filterState, [name]: value }
        setFilterState(newFilterState)
        const filteredUsers = applyFilter(users, newFilterState)
        setUsers(filteredUsers)
    }

    const labelEnabledDisabled = 'Aktiverade / inaktiverade'
    const labelUserCategory = 'Typ'

    return (
        <>
            <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
                <InputLabel id='user-category-filter'>{labelUserCategory}</InputLabel>
                <Select
                    labelId='user-category-filter'
                    id='user-category-filter-select'
                    name='userCategory'
                    label={labelUserCategory}
                    onChange={handleChange}
                    value={filterState.userCategory}
                >
                    <MenuItem value='all'>Alla</MenuItem>
                    <MenuItem value='standard'>Betalande</MenuItem>
                    <MenuItem value='trial'>Test</MenuItem>
                    <MenuItem value='inhouse'>Finance Lab</MenuItem>
                </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 200 }}>
                <InputLabel id='users-filter'>{labelEnabledDisabled}</InputLabel>
                <Select
                    labelId='users-filter'
                    id='users-filter-select'
                    name='enabledDisabled'
                    label={labelEnabledDisabled}
                    onChange={handleChange}
                    value={filterState.enabledDisabled}
                >
                    <MenuItem value='all'>Alla</MenuItem>
                    <MenuItem value='enabled'>Aktiverade</MenuItem>
                    <MenuItem value='disabled'>Inaktiverade</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}

export default UsersFilter
